<ng-container>
    <div class="flex justify-content-between">
        <div>
            <app-switch-input id="showDeactivated" [form]="form"
                label="folder.forms.showDeactivated"></app-switch-input>
        </div>
        @if (isAllowed['form.create']() && !folderStore.isTerminated()) {
            <div class="flex justify-content-end">
                @if (formOptions.length) {
                    <app-button
                        icon="pi-plus"
                        label="folder.forms.newSet"
                        (click)="folderFormFormModalVisible = true"
                    ></app-button>
                }
            </div>
        }
    </div>

    <app-table
        [items]="store.data.folderForms$ | async"
        [columns]="columns"
        translatePrefix="folder.forms.setsTable."
        [hideCheckboxes]="true"
        (detailCallback)="openEditFolderForm($event)"
        (deleteCallbackWithEvent)="deleteFolderForm($event)"
        [rowExpansion]="rowExpansion"
        [resource]="resource"
        [showDelete]="folderStore.canEdit()"
    >
        <ng-template pTemplate="changeActivationHeader"></ng-template>
        <ng-template pTemplate="changeActivation" let-item="item">
            <app-button [svgIcon]="item.active ? 'slash-circle' : 'arrow-clockwise'"
                [severity]="item.active ? 'warn' : 'success'" [text]="true" styleClass="p-button-set-icon-size"
                [pTooltip]="('folder.forms.setsTable.' + (item.active? 'de' : '') + 'activateTooltip') | translate"
                (clickEvent)="changeActiveStatusOfFolderForm(item)"></app-button>
        </ng-template>

        <ng-template #rowExpansion let-item="item">
            @if (isAllowed['form.create']() && !folderStore.isTerminated()) {
                <div class="flex">
                    <app-button
                        icon="pi-plus"
                        label="folder.forms.newRecord"
                        (clickEvent)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier)"
                    ></app-button>
                </div>
            }

            <div>
                @switch (item.uniqueIdentifier) {
                    @case (FormSetEnum.ESAS) {
                        <app-form-esas-table
                            [items]="item.folderFormData"
                            (editFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event)"
                            (printFormData)="openPrintFormDataModal($event)"
                            (copyFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event, true)"
                            (deleteFormData)="deleteRecordFormData($event)"
                            [resource]="resource"
                        ></app-form-esas-table>
                    }
                    @case (FormSetEnum.MSSE) {
                        <app-form-msse-table
                            [items]="item.folderFormData"
                            (editFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event)"
                            (printFormData)="openPrintFormDataModal($event)"
                            (copyFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event, true)"
                            (deleteFormData)="deleteRecordFormData($event)"
                            [resource]="resource"
                        ></app-form-msse-table>
                    }
                    @case (FormSetEnum.IADL) {
                        <app-form-iadl-table
                            [items]="item.folderFormData"
                            (editFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event)"
                            (printFormData)="openPrintFormDataModal($event)"
                            (copyFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event, true)"
                            (deleteFormData)="deleteRecordFormData($event)"
                            [resource]="resource"
                        ></app-form-iadl-table>
                    }
                    @case (FormSetEnum.DEKN) {
                        <app-form-dekn-table
                            [items]="item.folderFormData"
                            (editFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event)"
                            (printFormData)="openPrintFormDataModal($event)"
                            (copyFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event, true)"
                            (deleteFormData)="deleteRecordFormData($event)"
                            [resource]="resource"
                        ></app-form-dekn-table>
                    }
                    @case (FormSetEnum.PPS) {
                        <app-form-pps-table
                            [items]="item.folderFormData"
                            (editFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event)"
                            (printFormData)="openPrintFormDataModal($event)"
                            (copyFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event, true)"
                            (deleteFormData)="deleteRecordFormData($event)"
                            [resource]="resource"
                        ></app-form-pps-table>
                    }
                    @case (FormSetEnum.OPZ) {
                        <app-form-opz-table
                            [items]="item.folderFormData"
                            (editFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event)"
                            (printFormData)="openPrintFormDataModal($event)"
                            (copyFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event, true)"
                            (deleteFormData)="deleteRecordFormData($event)"
                            [resource]="resource"
                        ></app-form-opz-table>
                    }
                    @case (FormSetEnum.BI) {
                        <app-form-bi-table
                            [items]="item.folderFormData"
                            (editFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event)"
                            (printFormData)="openPrintFormDataModal($event)"
                            (copyFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event, true)"
                            (deleteFormData)="deleteRecordFormData($event)"
                            [resource]="resource"
                        ></app-form-bi-table>
                    }
                    @case (FormSetEnum.NI) {
                        <app-form-ni-table
                            [items]="item.folderFormData"
                            (editFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event)"
                            (printFormData)="openPrintFormDataModal($event)"
                            (copyFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event, true)"
                            (deleteFormData)="deleteRecordFormData($event)"
                            [resource]="resource"
                        ></app-form-ni-table>
                    }
                    @case (FormSetEnum.RVD) {
                        <app-form-rvd-table
                            [items]="item.folderFormData"
                            (editFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event)"
                            (printFormData)="openPrintFormDataModal($event)"
                            (copyFormData)="folderFormRecord.openRecordForm(item.id, item.uniqueIdentifier, $event, true)"
                            (deleteFormData)="deleteRecordFormData($event)"
                            [resource]="resource"
                        ></app-form-rvd-table>
                    }
                }
            </div>
        </ng-template>
    </app-table>
</ng-container>

<p-dialog
    header="{{ 'folder.forms.folderFormForm.' + (folderFormForm.controls.id.value? 'edit' : 'create') + 'Header' | translate }}"
    [(visible)]="folderFormFormModalVisible"
    [modal]="true"
    [maximizable]="true"
    [draggable]="true"
    [resizable]="true"
    (onHide)="closeFolderForm()"
>
    <div class="grid-1col input-grid-gaps">
        <div>
            <app-text-input
                id="name"
                [form]="folderFormForm"
                label="folder.forms.folderFormForm.name"
            ></app-text-input>
        </div>
        <div>
            <app-select-input
                id="form"
                [form]="folderFormForm"
                label="folder.forms.folderFormForm.form"
                [staticOptions]="formOptions"
                valueKey="id">
                <ng-template #item let-data>
                    {{ data.name + (data.abbreviation ? ' - ' + data.abbreviation : '') }}
                </ng-template>
                <ng-template #selectedItem let-data>
                    {{ data.name + (data.abbreviation ? ' - ' + data.abbreviation : '') }}
                </ng-template>
            </app-select-input>
        </div>
        <div>
            <app-text-input
                id="comment"
                [form]="folderFormForm"
                label="folder.forms.folderFormForm.comment"
            ></app-text-input>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <app-action-buttons
            [primaryButtonVisibility]="folderFormForm.enabled"
            (primaryClickEvent)="submitFolderForm()"
            (secondaryClickEvent)="closeFolderForm()"
        ></app-action-buttons>
    </ng-template>
</p-dialog>

<app-folder-forms-record-modal (onCreated)="loadForms()"></app-folder-forms-record-modal>

<p-dialog
    header="{{ 'folder.forms.printFormDataModal.header' | translate }}"
    [(visible)]="printFormDataModalVisible"
    [modal]="true"
    [maximizable]="false"
    [draggable]="false"
    [resizable]="false"
    (onHide)="closePrintFormDataModal()"
>
    <app-check-input
        id="archive"
        [form]="printFormDataForm"
        label="folder.forms.printFormDataModal.archive"
    ></app-check-input>

    <ng-template #footer>
        <app-action-buttons
            primaryButtonLabel="confirmDialog.confirmButton"
            [primaryButtonLoading]="printing"
            [secondaryButtonLoading]="printing"
            (primaryClickEvent)="printRecordFormData()"
            (secondaryClickEvent)="closePrintFormDataModal()"
        ></app-action-buttons>
    </ng-template>
</p-dialog>
